import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {useSongDetailsDisplaySelectedLesson} from "../../hooks/useSongDetailsDisplaySelectedLesson";

export interface ISongDetailsLessonPlayActionLogic {
  navigateToLessonPlayerHandler: () => void;
}

export const useSongDetailsLessonPlayActionLogic = (): ISongDetailsLessonPlayActionLogic => {
  const {lessonId: routerLessonId, firstLessonId} = useSongDetailsDisplaySelectedLesson();

  const lessonId = routerLessonId ?? firstLessonId ?? 0;
  const navigate = useNavigate();

  const navigateToLessonPlayerHandler = useCallback(
    () => navigate(`/lesson/${lessonId}`),
    [lessonId]
  );

  return {
    navigateToLessonPlayerHandler,
  };
}
